<template>
  <master-main
    :exportProperties="{
      pdf: {
        filename: `${$t('labor.workers')}.pdf`,
        route: `${getModuleRoute}/pdf`,
      },
      xls: {
        filename: `${$t('labor.workers')}.xlsx`,
        route: `${getModuleRoute}/excel`,
      },
    }"
    :route="getModuleRoute"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-worker
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>
<script>
import EditCreate from './EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import WorkerTable from './workers-table';
import i18n from 'src/i18n';

export default {
  components: { MasterMain, [EditCreate.name]: EditCreate },
  data() {
    return {
      tableProperties: {},
    };
  },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  computed: {
    getModuleRoute() {
      return 'works/workers';
    },
    buildTableProperties() {
      return {
        tableColumns: [...WorkerTable().tableColumns],
        model: 'worker',
        effectTags: 'dark',
        widthColumnStatus: 160,
        defaultSort: { prop: 'code', order: 'ascending' },
        addColumns: [
          {
            data: 'bonuses',
            label: i18n.t('labor.bonus'),
            field: 'name',
          },
        ],
      };
    },
  },
};
</script>
